import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation RemoveSpaceRecordFromCluster(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
    $spaceRecordId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                removeSpaceRecordFromCluster(
                  clusterId: $clusterId
                  spaceRecordId: $spaceRecordId
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.RemoveSpaceRecordFromClusterMutation,
  undefined,
  graphql.schema.RemoveSpaceRecordFromClusterMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
